<template>
    <div>


        <section id="signin">


            <div class="columns mt0 mb0 pb0">

                <div class="column fullcol is-7 is-hidden-touch">
                    <div class="loginbg" :style="'background-image:url(\'/static/images/signin/Imagem'+rdm+'.jpg\')'">

                        <p class="loginbg-txt">
                            O FACILIMO É A PLATAFORMA QUE <br>
                            AJUDA A REALIZAR PROJECTOS
                        </p>


                        <div class="loginbgsocial">
                            <p>
                                SIGA-NOS
                            </p>
                            <p>
                               <i class="fa fa-facebook-square"></i>
                               <i class="fa fa-instagram"></i>
                               <i class="fa fa-linkedin-square"></i>
                            </p>

                        </div>


                    </div>

                </div>

                <div class="column fullcol is-5-desktop" id="rightcol" style="background-color: #f1f1f1; display:flex; flex-direction:column;">


                    <div class="formcontainer" style="height:100%;">


                        <div class="loginaction">



                            <div class="loginlogo" @click="$router.push({path:'/'})" style="cursor:pointer;">
                                <img src="/static/images/layout/logotop.png" alt="FACILIMO">
                            </div>

                            <div id="signinflow">

                                <transition name="fade">

                                    <div id="flow-step-1">

                                        <p id="aceda">ESQUECI A MINHA PASSWORD</p>

                                        <div class="step1container">

                                            <form>

                                                <div class="columns">
                                                    <div class="column ">
                                                        <input :class="{'badinput': errors.has('email')}" class="formfield" type="text" name="email" data-vv-as="e-mail" v-model="email" v-validate="'required|email'" placeholder="E-mail">
                                                    </div>
                                                </div>

                                            </form>

                                        </div>

                                    </div>

                                </transition>

                            </div>

                            <div class="procceed" style="margin-top: 3rem;">
                                <a class="button is-primary" @click="resetPass" style="margin:0; font-weight: 600;">
                                    REDEFINIR PASSWORD
                                </a>

                                <p class="loginprompt">Não tem conta? <router-link to="registo" id="loginprompt">Registe-se aqui</router-link></p>
                            </div>

                            <div class="procceed" style="margin-top: 0;" >


                                <a class="button" @click="googleSignIn" style="
                                margin:0;
                                margin-top:0.5rem;
                                border: solid 1px rgba(0,0,0,0.54);
                                color:rgba(0,0,0,0.54);
                                background-color:#ffffff;
                                padding: 11px 8px;
                                font-size: 14px;
                                height:40px;
                                line-height:18px;
                                font-weight: 500;
                                border-radius:2px;
                                width:20rem;
                                ">
                                    <img src="/static/images/signin/g-logo.png" style="height:18px;margin-right: 18px;"/>
                                    Login com Google

                                </a>

                                <!--  <div id="googleButton"></div>-->

                            </div>

                        </div>

                    </div>



                </div>

            </div>

        </section>

        <transition name="fade">
            <div class="modal" :class="{'is-active': loading}">
                <div class="modal-background" style="background-color: rgba(10, 10, 10, 0.50);">

                    <i class="fa fa-spinner fa-pulse fa-3x" style="position: absolute;top: 50%;left: 50%;"></i>

                </div>

            </div>
        </transition>

    </div>

</template>

<script>
import { store } from "../store";
import { mask } from "vue-the-mask";
import { apiUrl } from "../vars";
import { removeChatMixin } from "../plugins/removeChatMixin";
import { notificationMixin } from "../plugins/notificationMixin";
import VueScript2 from "vue-script2";
import {
  loadFbSdk,
  getFbLoginStatus,
  fbLogout,
  fbLogin
} from "../plugins/facebook";

export default {
  mixins: [removeChatMixin, notificationMixin],

  data() {
    return {
      loading: false,
      email: null,
      password: null,
      hide: true,
      remember: false,
      rdm: 1,

      //Google login
      auth2: null,
      gapi: null,

      //Facebook login
      isConnected: false,
      appId: 1776286176001743,
      version: "v2.12"
    };
  },

  created() {
    this.rdm = Math.ceil(Math.random() * 3);

    let that = this;

    VueScript2.load("https://apis.google.com/js/platform.js").then(function() {
      gapi.load("auth2", function() {
        that.auth2 = gapi.auth2.init({
          client_id:
            "80577240297-m013um4b4hpttqla0phhop4qgi038ag6.apps.googleusercontent.com",
          fetch_basic_profile: true
        });
      });
      that.gapi = gapi;
    });

    loadFbSdk(this.appId, this.version)
      .then(getFbLoginStatus)
      .then(response => {
        if (response.status === "connected") {
          this.isConnected = true;
        }
        this.isWorking = false;
        /** Event `get-initial-status` to be deprecated in next major version! */
        this.$emit("get-initial-status", response);
        this.$emit("sdk-loaded", {
          isConnected: this.isConnected,
          FB: window.FB
        });
      });
  },

  computed: {
    googleAvailable() {
      return this.gapi && this.auth2;
    }
  },

  methods: {
    login() {
      fbLogin({ scope: "email" }).then(response => {
        if (response.status === "connected") {
          this.isConnected = true;
        } else {
          this.isConnected = false;
        }
        this.$emit("login", {
          response,
          FB: window.FB
        });
      });
    },

    buttonClicked() {
      this.$emit("click");
      this.login();
    },

    googleSignIn() {
      let that = this;
      // Sign the user in, and then retrieve their ID.
      this.auth2.signIn().then(function(response) {
        that.onSignIn();
      });
    },

    googleSignOut() {
      let that = this;
      // Sign the user in, and then retrieve their ID.
      this.auth2.signOut().then(function() {
        console.log("signed out");
      });
    },

    onSignIn() {
      let u = this.auth2.currentUser.get();
      let id_token = u.getAuthResponse().id_token;

      if (u) {
        let profile = u.getBasicProfile();
        let name = profile.getName();
        //console.log('Image URL: ' + profile.getImageUrl());
        let email = profile.getEmail();

        axios
          .post(apiUrl + "auth/google/token", { id_token: id_token })
          .then((response, context = this) => {
            console.log(response);

            if (response.data.newuser) {
              context.$router.push({
                name: "signup",
                params: {
                  email: email,
                  name: name,
                  p1: response.data.p1
                }
                //name: 'fetch'
              });
              return;
            }

            if (response.data.token) {
              context.error = null;
              context.$store.commit("setToken", response.data.token);
              //context.$store.commit('setExpires', response.data.expiration);
              context.$router.push({
                name: "home",
                params: {
                  message: "Login efetuado com sucesso!"
                }
                //name: 'fetch'
              });
              return;
            }

            if (response.data.invalid) {
              context.error = "Erro ao validar as credenciais.";
            }
          });
      }
    },

    resetPass() {
      let that = this;
      this.loading = true;

      this.$validator.validateAll().then(result => {
        if (result) {
          let o = {
            email: this.email
          };
          axios
            .post(apiUrl + "/auth/forgot", o)
            .then((response, context = this) => {
              context.error = null;
              context.loading = false;

              context.$router.push({
                name: "home",
                params: {
                  message:
                    "Se o endereço de e-mail fornecido estiver no banco de dados, em breve receberá uma mensagem com instruções para a redefinição da password."
                }
                //name: 'fetch'
              });
            })
            .catch((error, context = this) => {
              //context.l_login = false;

              switch (error.response.status) {
                case 500:
                  context.error =
                    "Erro no servidor. Favor tentar novamente mais tarde.";
                  break;
                case 401:
                  context.error = "E-mail e/ou password inválidos.";
                  break;
                default:
                  context.error =
                    "Erro " +
                    error.response.status +
                    ": " +
                    error.response.statusText;
              }
              //context.l_login = false;
            });
        }
        that.error = "Verifique o endereço de e-mail informado.";
        this.loading = false;
      });
    }
  },

  watch: {}
};
</script>

<style scoped lang="scss">
.signup {
  padding: 1rem 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.button2 {
  margin-left: 1rem;
  font-size: 0.8rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}

.button2:hover {
  background-color: white !important;
}

#signin {
  position: relative;
}

#signin .columns {
  position: relative;
}

#signin .fullcol {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  padding: 0;
}

.loginbg {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.loginbg-txt {
  text-align: center;
  font-size: 1.35rem;
  color: white;
  font-weight: 600;
  line-height: 1.2;
}

.loginbgsocial {
  text-align: center;
  padding: 4rem 0 2rem;
}

.loginbgsocial p {
  text-align: center;
  color: #e90054;
  font-size: 0.9rem;

  font-weight: 600;
}

.loginbgsocial i {
  text-align: center;
  font-size: 1.15rem;
  color: white;
  padding: 0.3rem;
  font-weight: 500;
}

.loginaction {
  background-color: #f1f1f1;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.loginlogo {
  padding: 4.5rem 0 0;
}

#aceda {
  margin-top: 5rem;
  color: #2d3256;
  font-weight: 600;
  text-align: left;
  padding: 1rem 0;
  font-size: 1.2rem;
}

.step1container {
  padding: 1rem 0;
}

.loginprompt {
  margin-top: 1rem;
  color: #848a96;
  font-size: 0.8rem;
}

#loginprompt {
  color: #e90054;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.8rem;
}

form .column {
  padding: 0.3rem;
}

.loginlogo img {
  height: 3rem;
}

.formfield {
  //border: solid 1px #848a96;
  background-color: white;
  padding: 0.5rem;
  width: 100%;
  font-size: 0.9rem;
}

.fbbut {
  border: none;
  margin: 0.1rem;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.fbbut:hover {
  border: none;
}

.gobut {
  border: none;
  margin: 0.1rem;
  justify-content: left;
  padding-left: 1rem;
  padding-right: 1rem;
}

.gobut:hover {
  border: none;
}

.procceed {
  text-align: center;
  padding: 0 0 4.5rem;
}

.procceed .button {
  padding: 1.25rem 3rem;
  font-size: 0.85rem;
  margin: 1rem;
}

.formcontainer {
  margin: auto;
  margin-bottom: 6rem;
  max-width: 20rem;
  min-width: 20rem;
}

input {
  border: solid 1px #f1f1f1;
}

.badinput {
  border: solid 1px #e90054 !important;
}

@media screen and (max-width: 768px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 570px) and (min-width: 769px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 720px) {
  .procceed {
    text-align: center;
    padding: 0 0 3rem;
  }

  .loginlogo {
    padding: 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue